import React, { useState } from "react";
import ReactDOM from "react-dom";
import '../styles.css'
import "../components/imagebutton.css";

export default function ImageButton({ buttonName, image }) {
  const [showImage, setShowImage] = useState(false);

  return (
    <>
      <button className="button" onClick={() => setShowImage(true)}>
        {buttonName}
      </button>

      {showImage && ReactDOM.createPortal(
        <div className="overlay-image" onClick={() => setShowImage(false)}>
          <div
            className="modal-image-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={() => setShowImage(false)}>
              &times;
            </button>
            <img
              src={image}
              alt={buttonName}
              className="modal-image"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
        </div>,
        document.body // <- Aquí forzamos que se renderice al nivel del body
      )}
    </>
  );
}
